import PropTypes from 'prop-types';
import { Star } from 'lucide-react';

/**
 * Google Maps Location Button
 * Opens the business location in Google Maps
 */
function GoogleReviewButton({
  className = '',
}) {
  const googleMapUrl =
    'https://www.google.com/maps/search/?api=1&query=Dubai+Merchant+Mall+Ronald+Ngala+Street+Shop+G18+Nairobi';

  return (
    <a
      href={googleMapUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={
        className ||
        'mt-5 inline-flex items-center justify-center gap-2 rounded-full bg-[#1a73e8] px-4 py-3 text-sm font-semibold text-white transition hover:bg-[#165ab8] active:scale-95'
      }
      aria-label="Open our location in Google Maps"
    >
      <Star size={18} fill="currentColor" />
      View location on Google Maps
    </a>
  );
}
GoogleReviewButton.propTypes = {
  className: PropTypes.string,
};

export default GoogleReviewButton;
